import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import AppContext from 'context/appContext/appContext';

import App from './App';

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <AppContext>
        <App />
      </AppContext>
    ),
  },
]);

export { router };
